import * as Account from 'api/account'
import router from 'src/router'

// 检查当前登录状态

let user = null

export let set = u => {
  user = u
  if (!u) return
  // 设置角色，如：$$is_super: true
  if (user.role) user['$$is_' + user.role] = true
  // 设置教师角色，如：{manager: true, teacher: true}
  user.roles = user.roles || []
  if (user.$$is_teacher && !user.roles.length) user.roles.push('teacher')
  user.$$roles = Object.create(null)
  user.roles.forEach(role => user.$$roles[role] = true)
  // 设置权限，如：{admin_group: true, admin_teacher: true}
  user.auth = user.auth || []
  user.$$auth = Object.create(null)
  user.auth.forEach(auth => user.$$auth[auth] = true)
  return user
}

export let get = () => user

export let check = async () => user || set(await Account.own())

export function logout () {
  Account.logout()
  user = null
  router.replace('/login')
}

const install = function (Vue) {
  if (install.installed) return
  // 登出
  Vue.prototype.$logout = logout
}

export let plugin = {install}



// WEBPACK FOOTER //
// ./src/common/session.js